import GenericCard from './GenericCard';

export default GenericCard;
